import { ResultOf } from "@graphql-typed-document-node/core";
import { graphql } from "@/gql";

export const googleMapsAddressLookupQuery = graphql(`
  query GoogleMapsAddressLookup($input: GoogleMapsAutocompleteInput!) {
    googleMapsAutocomplete(input: $input) {
      placeId
      text {
        text
      }
    }
  }
`);

export const googleMapsPlaceDetailsQuery = graphql(`
  query GoogleMapsPlace($placeId: ID!) {
    googleMapsPlace(placeId: $placeId) {
      id
      addressComponents {
        longText
        shortText
        types
      }
      formattedAddress
      displayName {
        text
      }
      types
      primaryType
      location {
        latitude
        longitude
      }
      verifiedLocality {
        city
        suburb
        state
        postcode
      }
    }
  }
`);

export type GoogleMapsPlaceDetails = ResultOf<
  typeof googleMapsPlaceDetailsQuery
>["googleMapsPlace"];
